import { OpaccNavigation } from './classes/opacc.class.navigation.js';


/**
 * Clientseitige Funktionalität im Modul "Navigation"
 *
 * @module navigation
 */

export const opaccNavigationPlugin = new OpaccNavigation();